module.exports = __webpack_public_path__ + "static/img/bookdoc.default.fb88c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bookdoc.default.png
// module id = 1158
// module chunks = 382